import { StyledMainContent } from "./styled";
import { IMainContentProps } from "./types";
import { useDrawerStore } from "src/store/drawerStore";
import { useSidebarStore } from "src/store/sidebarStore";

const MainContent = ({children, ...props}:IMainContentProps)=>{
    const open = useDrawerStore((s: any) => s.open);
    const chatWidth = useDrawerStore((s: any) => s.width);
    const isResizing = useDrawerStore((s: any) => s.isResizing);
    const sidebarOpen = useSidebarStore((s: any) => s.open);
    return (
        <StyledMainContent
            open={open}
            sidebarOpen={sidebarOpen}
            chatWidth={chatWidth}
            isResizing={isResizing}
            {...props}
        >
            {children}
        </StyledMainContent>
    )
}

export {MainContent}
